import {
    SET_BULK_ORDER_BY_ID
} from "./BulkOrderByIdType"

const initialState = {
    bulkOrderbyIdValue: null
}


const reducer = (state = initialState, action: any) => {
    if (action.type === SET_BULK_ORDER_BY_ID) {
        return {
            ...state,
            bulkOrderbyIdValue: action.bulkOrderbyIdValue,
        };
    }
    else {
        return state;
    }
};

export default reducer;